import React, {PropTypes} from 'react';

const PetAdPreview = ({
	ad 
}) => {
	let adClass = "aspace-placeholder ";
	if(!ad.isValid)
	{
		adClass += "aspace-bg";
	}

	return (
		<div className={adClass}>
			{ad.isValid && <img src={ad.imageUrl}/>}
		</div>
	);
};

PetAdPreview.propTypes = {
	ad: PropTypes.object.isRequired
};

export default PetAdPreview;


/** WEBPACK FOOTER **
 ** ./src/modules/caresheets/components/PetAdPreview.js
 **/